var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGwt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1540_230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1540_230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0395 25.1403C33.168 25.0068 33.2399 24.8277 33.2399 24.6412C33.2399 24.4547 33.168 24.2755 33.0395 24.142L26.1945 17.2055C26.0628 17.0753 25.886 17.0023 25.702 17.0023C25.5179 17.0023 25.3412 17.0753 25.2094 17.2055L3.20049 39.4962C3.07195 39.6297 3 39.8088 3 39.9953C3 40.1818 3.07195 40.361 3.20049 40.4945L25.2083 62.7968C25.34 62.9271 25.5168 63 25.7008 63C25.8849 63 26.0617 62.9271 26.1934 62.7968L33.0383 55.8603C33.1668 55.7268 33.2388 55.5477 33.2388 55.3611C33.2388 55.1746 33.1668 54.9955 33.0383 54.862L18.8756 40.5038C18.747 40.3703 18.6751 40.1912 18.6751 40.0047C18.6751 39.8182 18.747 39.639 18.8756 39.5055L33.0395 25.1403ZM54.8021 17.2032C54.6704 17.0729 54.4936 17 54.3096 17C54.1255 17 53.9488 17.0729 53.817 17.2032L31.8393 39.4657C31.7107 39.5992 31.6388 39.7783 31.6388 39.9648C31.6388 40.1514 31.7107 40.3305 31.8393 40.464L38.6842 47.4123C38.8159 47.5425 38.9927 47.6154 39.1768 47.6154C39.3608 47.6154 39.5376 47.5425 39.6693 47.4123L53.817 33.0775C53.9488 32.9473 54.1255 32.8744 54.3096 32.8744C54.4936 32.8744 54.6704 32.9473 54.8021 33.0775L61.136 39.4962C61.2645 39.6297 61.3365 39.8088 61.3365 39.9953C61.3365 40.1818 61.2645 40.361 61.136 40.4945L46.9721 54.8479C46.8436 54.9814 46.7716 55.1606 46.7716 55.3471C46.7716 55.5336 46.8436 55.7127 46.9721 55.8462L53.817 62.7828C53.9488 62.913 54.1255 62.9859 54.3096 62.9859C54.4936 62.9859 54.6704 62.913 54.8021 62.7828L76.7995 40.4921C76.9281 40.3586 77 40.1795 77 39.993C77 39.8064 76.9281 39.6273 76.7995 39.4938L54.8021 17.2032Z",
    fill: "#F93535"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGwt);
export default __webpack_public_path__ + "static/media/GWT.b8ba6039106eda6e54b3f4a650ef3dd1.svg";
export { ForwardRef as ReactComponent };